import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'antd';
import { fetchStatusModalCor, fetchUpdateTheme } from 'store/fetchActions/fetchApp';
import { ENUM_THEME, STORAGE_THEME_CUSTOM_FAS, ENUM_COLOR_LIGHT } from 'utils/consts';
import * as S from './style';

export const ModalColor = () => {
  const dispatch = useDispatch();

  const thisModalState = useSelector(state => state.app.modalCor);

  const getDefaultColor = nameColor => {
    return getComputedStyle(document.documentElement).getPropertyValue(nameColor);
  };

  const onClose = () => {
    dispatch(fetchStatusModalCor(false));
  };

  const [color, setColor] = React.useState({});

  React.useEffect(() => {
    setColor({
      '--primary-color-sefaz': getDefaultColor('--primary-color-sefaz'),
      '--background-color-sefaz': getDefaultColor('--background-color-sefaz'),
      '--background-second-sefaz': getDefaultColor('--background-second-sefaz'),
      '--bottom-color-sefaz': getDefaultColor('--bottom-color-sefaz'),
      '--texto-color': getDefaultColor('--texto-color'),
      '--cinza-color': getDefaultColor('--cinza-color'),
    });
    // eslint-disable-next-line
  }, []);

  const getDescription = name => {
    if (name === '--primary-color-sefaz') return 'Cor principal do FAS';
    if (name === '--background-color-sefaz') return 'Cor do fundo das telas do FAS';
    if (name === '--background-second-sefaz') return 'Cor do Menu, Footer e Cards do FAS';
    if (name === '--bottom-color-sefaz') return 'Cor da caixa que separa o fundo do FAS (paper)';
    if (name === '--texto-color') return 'Cor dos textos do FAS';
    if (name === '--cinza-color') return 'Cor dos textos secundários do FAS';
    return name;
  };

  const change = event => {
    const { name, value } = event.target;
    document.body.style.setProperty(name, value);
    document.documentElement.style.setProperty(name, value);
    const newListColor = { ...color, [name]: value };
    setColor(newListColor);
    localStorage.setItem(STORAGE_THEME_CUSTOM_FAS, JSON.stringify(newListColor));
    dispatch(fetchUpdateTheme(ENUM_THEME.CUSTOM));
  };

  const changeDefault = () => {
    const listDefaultColor = {
      '--primary-color-sefaz': ENUM_COLOR_LIGHT['primaryColorSefaz'],
      '--background-color-sefaz': ENUM_COLOR_LIGHT['backgroundColorSefaz'],
      '--background-second-sefaz': ENUM_COLOR_LIGHT['backgroundSecondSefaz'],
      '--bottom-color-sefaz': ENUM_COLOR_LIGHT['bottomColorSefaz'],
      '--texto-color': ENUM_COLOR_LIGHT['textoColor'],
      '--cinza-color': ENUM_COLOR_LIGHT['cinzaColor'],
    };
    localStorage.removeItem(STORAGE_THEME_CUSTOM_FAS);
    dispatch(fetchUpdateTheme(ENUM_THEME.LIGHT));
    onClose();
    setColor(listDefaultColor);
    window.location.reload();
  };

  const getInput = () => {
    const arrayInput = [];
    Object.keys(color).forEach(key => {
      arrayInput.push(
        <S.ContainerSwitch key={key}>
          <input type="color" id={key} name={key} value={color[key]} onChange={e => change(e)} />
          <div className="info">
            <h1 style={{ color: color[key] }}>Cor</h1>
            <p>{getDescription(key)}</p>
          </div>
        </S.ContainerSwitch>
      );
    });
    return arrayInput;
  };

  return (
    <Modal
      title={thisModalState?.title}
      centered
      visible={thisModalState?.isOpen}
      onCancel={onClose}
      width={800}
      closable={true}
      destroyOnClose
      footer={[
        <Button key="backDefault" onClick={changeDefault}>
          Voltar ao padrão
        </Button>,
        <Button key="back" onClick={onClose}>
          Fechar
        </Button>,
      ]}
    >
      <div>
        <S.Titulo>Personalização das cores</S.Titulo>
        <p style={{ textAlign: 'center' }}>
          A correta utilização das cores é um importante aliado para o equilíbrio dos ambientes e daqueles que os
          habitam, sendo gerador de bem estar, o que eleva a auto estima e reduz o stress, além de aumentar a
          produtividade. Você pode escolher as cores do sistema.
        </p>
        <div id="containerGeral" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          {getInput()?.map(input => {
            return input;
          })}
        </div>
      </div>
    </Modal>
  );
};

export default ModalColor;
